export const prefix = '/api/v1/opinion_pc';
export const intelligencePrefix = '/api/v1/intelligence_pc';
export const dashboardPrefix = '/api/v1/dashboard';
export const mockPrefix = '/mock/v1/opinion_pc';
export const permissionPrefix = '/api/v1/permission';
export const aigcPrefix = '/api/v1/ai';
export const mockAigcPrefix = '/mock/v1/ai';
